import { useLocalSearchParams } from 'expo-router';
import React from 'react';

import { FeedScreen } from '~/components/domain/posts/FeedScreen';

export default function HashtagFeed() {
  const { tag } = useLocalSearchParams<{ tag: string }>();

  if (!tag) {
    return null;
  }

  return <FeedScreen feedType="search" hashtag={`#${tag}`} />;
}
